import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { signoutRedirectCallback } from './userManager';

function SignoutOidc() {
	const navigate = useNavigate();

	useEffect(() => {
		async function signoutAsync() {
			await signoutRedirectCallback();
			navigate('/');
		}
		signoutAsync();
	}, [navigate]);

	return null;
}

export default SignoutOidc;
